var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEAgameIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.714 0A2.285 2.285 0 0 1 16 2.286v11.428A2.285 2.285 0 0 1 13.714 16H2.286A2.285 2.285 0 0 1 0 13.714V2.286A2.285 2.285 0 0 1 2.286 0h11.428Zm-3.399 6-2.96 4.808H4.112l.749-1.193h2.004l.74-1.191H3.122l-.73 1.191h1.073L2 12h6.02l2.295-3.74.831 1.353h-.714L9.7 10.808h2.177L12.608 12H14l-3.685-6ZM10 5H4.795L4 7h5.203L10 5Z",
  fill: "#757575",
  fillRule: "nonzero"
})));

export default SvgEAgameIcon;